/* eslint-disable @typescript-eslint/no-require-imports */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import React, {useEffect, useRef, useState} from 'react';
import {
  Dimensions,
  Image,
  Linking,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import {connect} from 'react-redux';
import {SITEARO} from '../../../../data/constants/alphabet';
import {BREAKPOINT} from '../../../../data/constants/screen';
import {StackParams} from '../../../../data/types/navigation';
import {ImageServices} from '../../../../services/applicatif/image';
import mapDispatchToProps from '../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../services/redux/mapStateToProps';
import globalStyle from '../../../styles/globalStyle';
import './headerweb.css';
import {styles} from './styles';

type NavigationProps = StackNavigationProp<StackParams, 'Home'>;

export function FHeaderScreen(props: any) {
  const {title, type, user, noBreadcrumb, signOutUser} = props;
  const info = {
    imageUrl: '',
    connexion: 'Se connecter',
  };
  const userConnected = useRef(false);
  const [profilePicture, setProfilePicture] = useState('');

  if (user && user.data && user.data.utilisateur) {
    userConnected.current = true;
    info.imageUrl = user.data.utilisateur.imageUrl;
    info.connexion = 'Se déconnecter';
  } else {
    userConnected.current = false;
  }
  const {navigate} = useNavigation<NavigationProps>();
  const handleLogin = () => {
    if (userConnected.current) {
      signOutUser({}, () => {
        navigate('Home');
      });
    } else {
      navigate('Login');
    }
  };
  const navigateToAro = async () => {
    const supported = await Linking.canOpenURL(SITEARO);

    if (supported) {
      await Linking.openURL(SITEARO);
    }
  };
  useEffect(() => {
    if (userConnected.current) {
      ImageServices()
        .getUtilisateurImage(info.imageUrl)
        .then(res => setProfilePicture(res))
        .catch(err => console.log(err));
    }
  }, [userConnected.current]);

  return (
    <div className="headersspace">
      <div className="headerWeb">
        <View style={[styles.headerlimit, globalStyle.containerFluid]}>
          <View style={styles.headerLeft}>
            {(type === 'home' || type === 'retour') && (
              <TouchableOpacity onPress={() => navigate('Home')}>
                <Image
                  style={styles.headerImageHome}
                  source={{
                    uri: require('../../../../ressources/images/LogoAro.png'),
                  }}
                />
              </TouchableOpacity>
            )}
            {type === 'GoToMonEspace' && (
              <TouchableOpacity onPress={() => navigate('Home')}>
                <Image
                  style={[styles.headerImageHome]}
                  source={{
                    uri: require('../../../../ressources/images/LogoAro.png'),
                  }}
                />
              </TouchableOpacity>
            )}
            {type === 'Unlogged' && (
              <TouchableOpacity onPress={() => navigate('Home')}>
                <Image
                  style={styles.headerImageHome}
                  source={{
                    uri: require('../../../../ressources/images/LogoAro.png'),
                  }}
                />
              </TouchableOpacity>
            )}
          </View>
          <View
            style={[
              {
                flexDirection: 'row',
              },
              Dimensions.get('window').width > BREAKPOINT.sm
                ? {}
                : {maxWidth: 200},
            ]}>
            <TouchableOpacity
              style={[
                {
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                },
              ]}
              onPress={navigateToAro}>
              <Image
                style={[
                  {
                    marginTop: 0,
                    width: 30,
                    height: 30,
                  },
                ]}
                source={{
                  uri: require('../../../../ressources/images/souscription_faculte.png'),
                }}
              />
              <Text
                style={[
                  globalStyle.titlePrimaryH2,
                  {fontWeight: 'bold', textAlign: 'center'},
                ]}>
                Souscrire à une assurance faculté
              </Text>
            </TouchableOpacity>
          </View>
          <View style={styles.headerPlaceProfil}>
            <View style={{flexDirection: 'row', alignItems: 'center'}}>
              {Dimensions.get('window').width >= 720 ? (
                <View>
                  <Text style={globalStyle.titlePrimaryH2}>Mon espace</Text>
                  <View style={styles.headerConnectLink}>
                    <TouchableOpacity>
                      <Text
                        style={styles.headerProfilText}
                        onPress={() => {
                          handleLogin();
                        }}>
                        {info.connexion}
                      </Text>
                    </TouchableOpacity>

                    {!userConnected.current && (
                      <>
                        <Text
                          style={[
                            styles.headerProfilTextSeparator,
                            globalStyle.colorLightPrimary,
                          ]}>
                          |
                        </Text>
                        <TouchableOpacity
                          onPress={() => navigate('Inscription')}>
                          <Text
                            style={[
                              styles.headerProfilText,
                              globalStyle.colorLightPrimary,
                            ]}>
                            Créer un compte
                          </Text>
                        </TouchableOpacity>
                      </>
                    )}
                  </View>
                </View>
              ) : (
                <Text></Text>
              )}

              <TouchableOpacity
                style={{flex: 1}}
                onPress={() => navigate('MonEspace')}>
                <Image
                  style={styles.headerImageProfil}
                  source={
                    !userConnected.current || profilePicture == ''
                      ? require('../../../../ressources/images/user_primary_ph.png')
                      : {
                          uri: profilePicture,
                        }
                  }
                />
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </div>
      {!noBreadcrumb && (
        <div className="filAriane">
          <TouchableOpacity onPress={() => navigate('Home')}>
            <span className="homeLink">Accueil</span>
          </TouchableOpacity>
          <span className="arianeLink">|</span>
          <span className="arianeLink">{title}</span>
        </div>
      )}
    </div>
  );
}

export const HeaderScreen: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FHeaderScreen);
